interface SvgProps {
	style?: object;
}

const ArrowRight = ({ style }: SvgProps) => {
	return (
		<svg focusable="false" height="20" width="20" style={style}>
			<g transform="translate(0, 0) scale(1)">
				<path
					d="M12.677,10.605 L8.677,15.738 L7.1,14.509 L10.62,9.991 L7.1,5.48 L8.677,4.25 L12.677,9.376 C12.959,9.737 12.959,10.244 12.677,10.605 Z"
					fill="rgba(95, 97, 99, 1)"
				></path>
			</g>
		</svg>
	);
};

export default ArrowRight;
